import {deleteJson, getJson, patchJson, postJson, putJson} from '@/util/ajaxUtils';
import {openGet, OPEN_APP_INFO_HEADERS} from '@/api/openAjaxUtils';

export function getWxConfig(appId, url) {
    return openGet(`/open/jssdk/config`, {params: {appId, url}});
}

export function openWxToken(code) {
    return getJson(`/open/jssdk/auth-token/${code}`);
}

export function openCutsomerInfo(userId) {
    return getJson(`/open/jssdk/customer-info/${userId}`);
}

export function saveAgreementInfo(appId, data) {
    return postJson(`/open/jssdk/agreement-info/add/${appId}`, {data: data});
}

export function getAgreementInfo(userId) {
    return getJson(`/open/jssdk/agreement-info/${userId}`);
}

export function updateAgreementInfo(data) {
    return postJson('/open/jssdk/agreement-info/update', {data: data});
}

export function getAuthUserInfo(code) {
    return getJson(`/open/getAuthUserInfo/${code}`);
}

export function getUserInfoByWecomCode(appId, code) {
    return openGet(`/open/wecom/userinfo`, {
        params: {appId, code},
        headers: OPEN_APP_INFO_HEADERS,
    });
}

// export function toServerId(externalUserId, wecomAppId) {
//     return getJson(`/open/jssdk/to-server/${externalUserId}/${wecomAppId}`);
// }
